import {XauditModel} from '../xaudit.model';

export class CfgARAccountModel extends XauditModel{
  ARAccountID: string;
  AccountName: string;
  AccountNumber: string;
  DoctorARLocId: string;
  isActiveDoctor: boolean;
}
